(ns frontend.ui.component.lp-portal.report.component.overview-figures.view
  (:require
   [common.util :as cu]
   [herb.core :as h]
   [frontend.ui.component.lp-portal.report.component.overview-figures.style :as style]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]))

(defn big-figure
  [{:keys [value label comment no-border?]}]
  [:div {:class (h/<class style/figure-container no-border?)}
   [:span {:class (h/<class style/figure)} value]
   [:span {:class (h/<class style/figure-label)} label]
   (when-not (or (= comment "-") (cu/blank-value? comment))
     [:span {:class (h/<class style/figure-comment)} comment])])

(defn overview-figures-card
  [{:keys [figures]}
   {:keys [no-border?]}]
  (let [filtered-figures (->> figures
                              (filterv (fn [[_label value _comment]]
                                         (not (cu/blank-value? value)))))]
    [card/card {}
     [grid/row {}
      [grid/column {}
       [:div
        {:style (when (= 2 (count figures))
                  {:max-width    "40%"
                   :margin-left  "auto"
                   :margin-right "auto"})}
        [grid/row {}
         (->> filtered-figures
              (filter (fn [[_label value _comment]]
                        (not (cu/blank-value? value))))
              (map (fn [[label value comment]]
                     ^{:key (str ::row "-" label)}
                     [:div {:class (h/<class style/figure-column (count filtered-figures))}
                      [big-figure {:value      value
                                   :label      label
                                   :comment    comment
                                   :no-border? no-border?}]]))
              (doall))]]]]]))
